/**
 * DLNA API 服务
 * 用于与后端DLNA服务进行通信
 */

import {GET, POST, PUT, DELETE, reUrl} from '../../axiosconfig/axiosconfig'

export default {
  discoverDevices: function(params) {
    return GET(reUrl + '/dlna/discover/', params)
  },  
  addManualDevice: function(params) {
    return POST(reUrl + '/dlna/add-device/', params)
  },
  queue: function(params) {
    return GET(reUrl + '/dlna/queue/', params)
  },
  /**
   * 连接到指定的DLNA设备
   * @param {string} deviceId 设备ID
   * @returns {Promise} 连接结果
   */
  async connect(deviceId) {
    try {
      const response = await POST(reUrl + '/dlna/connect/', {
        deviceId
      })
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('连接DLNA设备失败:', error)
      return {
        success: false,
        error: error.message
      }
    }
  },

  /**
   * 断开与DLNA设备的连接
   * @param {string} deviceId 设备ID
   * @returns {Promise} 断开连接结果
   */
  async disconnect(deviceId) {
    try {
      const response = await POST(reUrl + '/dlna/disconnect/', {
        deviceId
      })
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('断开DLNA设备连接失败:', error)
      return {
        success: false,
        error: error.message
      }
    }
  },

  /**
   * 推送音轨到DLNA设备
   * @param {string} deviceId 设备ID
   * @param {string} trackId 音轨ID
   * @param {number} currentTime 当前播放时间
   * @returns {Promise} 推送结果
   */
  async pushTrack(deviceId, trackId, currentTime = 0) {
    try {
      const response = await POST(reUrl + '/dlna/push-track/', {
        deviceId,
        trackId,
        currentTime
      })
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('推送音轨到DLNA设备失败:', error)
      return {
        success: false,
        error: error.message
      }
    }
  },

  /**
   * 控制DLNA设备播放
   * @param {string} deviceId 设备ID
   * @param {string} action 动作 (play, pause, stop, next, previous, seek)
   * @param {string} trackId 音轨ID (可选)
   * @param {object} extraParams 额外参数 (可选，如seek操作的position参数)
   * @returns {Promise} 控制结果
   */
  async control(deviceId, action, trackId=null, extraParams={}) {
    try {
      const requestData = {
        deviceId,
        action,
        trackId,
        ...extraParams
      }
      
      const response = await POST(reUrl + '/dlna/control/', requestData)
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('控制DLNA设备播放失败:', error)
      return {
        success: false,
        error: error.message
      }
    }
  },

  /**
   * 设置DLNA设备音量
   * @param {string} deviceId 设备ID
   * @param {number} volume 音量 (0-100)
   * @returns {Promise} 设置结果
   */
  async setVolume(deviceId, volume) {
    try {
      const response = await POST(reUrl + '/dlna/volume/', {
        deviceId,
        volume
      })
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('设置DLNA设备音量失败:', error)
      return {
        success: false,
        error: error.message
      }
    }
  },

  /**
   * 获取DLNA设备状态
   * @param {string} deviceId 设备ID
   * @returns {Promise} 设备状态
   */
  async getStatus(deviceId) {
    try {
      const response = await GET(reUrl + `/dlna/${deviceId}/status/`)
      return {
        success: true,
        status: response.data
      }
    } catch (error) {
      console.error('获取DLNA设备状态失败:', error)
      return {
        success: false,
        error: error.message
      }
    }
  }
} 